import { render, staticRenderFns } from "./PMReports.vue?vue&type=template&id=27f2b657&"
import script from "./PMReports.vue?vue&type=script&lang=ts&"
export * from "./PMReports.vue?vue&type=script&lang=ts&"
import style0 from "./PMReports.vue?vue&type=style&index=0&id=27f2b657&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports